import React, { useEffect, useState } from 'react';
import CookiesIcon from '../Assets/Images/remesalogo.png';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

function CookiesC() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dataLayer = window.dataLayer || [];
    if (!localStorage.getItem('cookies-aceptadas')) {
      setVisible(true);
    } else {
      dataLayer.push({ event: 'cookies-aceptadas' });
    }
  }, []);

  const aceptarCookies = () => {
    localStorage.setItem('cookies-aceptadas', true);
    setVisible(false);
    const dataLayer = window.dataLayer || [];
    dataLayer.push({ event: 'cookies-aceptadas' });
  };

  return (
    <AnimatePresence>
      {visible && (
        <>
          <motion.div
            className="fondo-aviso-cookies"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
          ></motion.div>

          <motion.div
  className="aviso-cookies"
  initial={{ y: 100, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  exit={{ y: 100, opacity: 0 }}
  transition={{ type: 'spring', stiffness: 80 }}
>
  <div className="galleta">
    <img src={CookiesIcon} alt="cookie" />
  </div>
  <div className="contenido-cookies">
    <h3 className="titulo">Cookies</h3>
    <p className="parrafo">
      Usamos cookies propias y de terceros para mejorar tu experiencia.
    </p>
    <div className="acciones">
      <button className="boton" onClick={aceptarCookies}>
        De acuerdo
      </button>
      <Link className="enlace" to="/Cookies">
        Más información
      </Link>
    </div>
  </div>
</motion.div>

        </>
      )}
    </AnimatePresence>
  );
}

export { CookiesC };
